import { render, staticRenderFns } from "./Group_Business.vue?vue&type=template&id=23423c65&scoped=true&"
import script from "./Group_Business.vue?vue&type=script&lang=js&"
export * from "./Group_Business.vue?vue&type=script&lang=js&"
import style0 from "./Group_Business.vue?vue&type=style&index=0&id=23423c65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23423c65",
  null
  
)

export default component.exports